import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'BannerSkeletons',
  values: {
    _mobile_numberOfBanners: 3,
    numberOfBanners: 1,
    scrollIntoCenter: false,
    _mobile_scrollIntoCenter: true,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          _mobile_padding: '4px 0',
          _mobile_boxSizing: 'border-box',
          overflow: 'hidden',
          _mobile_scrollSnapType: 'x mandatory',
          aspectRatio: '3.2 / 1',
          _mobile_aspectRatio: '2.75 / 1',
        },
      },
    },
    bannerSkeletonContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexShrink: 0,
          width: '100%',
        },
      },
    },
    bannerSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '100%',
          height: '100%',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
